<h2 mat-dialog-title>{{ 'FORM_V2.SUBMISSION_ERROR_DIALOG.TITLE' | translate }}</h2>
<mat-dialog-content class="dialog-error">
  <p>{{ 'FORM_V2.SUBMISSION_ERROR_DIALOG.CONTENT' | translate }}</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button color="primary" mat-dialog-close>
    {{ 'FORM_V2.SUBMISSION_ERROR_DIALOG.OK' | translate }}
  </button>
</mat-dialog-actions>
